import { defaults } from './default';

export const environment = {
  ...defaults,  
  identification: 'prod',
  production: true,
  qrCodeLinkPrefix: `https://digital.sabemi.com.br/formalizacao/selfie`,

  api: {
    ...defaults.api,
    baseUrl: 'https://api.sabemi.com.br/digitalapp/v1',
    //baseUrl: "https://api.sabemi.com.br/digitalapp/v1",
    environments: null,
  },
};
